const ROLES = {
    owner: {
        stats: {
            view: true,
        },
        web: {
            view: true,
            update: true,
            delete: true,
        },
        notifications: {
            view: true,
            update: true,
            delete: true,
        },
        settings: {
            view: true,
            update: true,
            delete: true,
        },
        'extra-items': {
            view: true,
            update: true,
            delete: true,
        },
        orders: {
            view: true,
            update: true,
            delete: true,
        },
        categories: {
            view: true,
            update: true,
            delete: true,
        },
        business: {
            view: true,
            update: true,
            delete: true,
        },
        'opening-hours': {
            view: true,
            update: true,
            delete: true,
        },
        colleagues: {
            view: true,
        },
        colleague: {
            view: true,
            create: true,
            update: true,
            remove: (user, colleague) => user.user_id !== colleague.id && colleague.role !== 'owner',
            changeRole: (user, colleague) => user.user_id !== colleague.id ,
        },
        billing: {
            view: true,
            create: true,
            delete: true,
            update: true
        },
        payment: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        reservation: {
            view: true,
            create: true,
            update: true,
            delete: true,
            accept: true,
            decline: true
        },
        invoice: {
            view: true,
            create: true,
        },
        order: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        subscription: {
            view: true,
            create: true,
            update: true,
            delete: true,
        }
    },
    manager: {
        stats: {
            view: true,
        },
        web: {
            view: true,
            update: true,
            delete: true,
        },
        notifications: {
            view: true,
            update: true,
            delete: true,
        },
        settings: {
            view: true,
            update: true,
            delete: true,
        },
        'extra-items': {
            view: true,
            update: true,
            delete: true,
        },
        orders: {
            view: true,
            update: true,
            delete: true,
        },
        categories: {
            view: true,
            update: true,
            delete: true,
        },
        business: {
            view: true,
            update: true,
        },
        'opening-hours': {
            view: true,
            update: true,
            delete: true,
        },
        colleagues: {
            view: true,
        },
        colleague: {
            view: true,
            create: true,
            update: (user, colleague) => user.user_id === colleague.id || colleague.role === 'employee',
            remove: (user, colleague) => user.user_id !== colleague.id && colleague.role !== 'owner',
            changeRole: (user, colleague) => user.user_id !== colleague.id,
        },
        billing: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        payment: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        reservation: {
            view: true,
            create: true,
            update: true,
            delete: true,
            accept: true,
            decline: true
        },
        invoice: {
            view: true,
            create: true,
        },
        order: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        subscription: {
            view: true,
            create: true,
            update: true,
            delete: true,
        }
    },
    employee: {
        dashboard: {
            view: false,
        },
        stats: {
            view: false,
        },
        colleagues: {
            view: true,
        },
        colleague: {
            view: (user, colleague) => user.user_id === colleague.id,
            create: false,
            update: (user, colleague) => user.user_id === colleague.id,
            remove: false,
            changeRole: false
        },
        billing: {
            create: false,
            update: false,
            delete: false,
        },
        payment: {
            create: false,
            update: false,
            delete: false,
        },
        reservation: {
            view: true,
            create: true,
            update: (user, reservation) => reservation.price.colleague.id === user.user_id,
            delete: (user, reservation) => reservation.price.colleague.id === user.user_id,
            accept: (user, reservation) => reservation.price.colleague.id === user.user_id,
            decline: (user, reservation) => reservation.price.colleague.id === user.user_id
        },
        invoice: {
            view: false,
            create: false,
        },
        order: {
            view: true,
            create: true,
            update: false,
            delete: false,
        },
        subscription: {
            view: true,
            create: false,
            update: false,
            delete: false,
        }
    },
};

const hasPermission = (user, resource, action, data) => {
    const role = user?.role
    if (!role) return false
    const permission = ROLES[role]?.[resource]?.[action]
    if (permission == null) return false;
    if (typeof permission === "boolean") return permission;
    return data != null && permission(user, data);
}

export {hasPermission}
